module.exports = __webpack_public_path__ + "img/reference39.2a07f85f.jpg";